import Header from "./Header/Header";
import Content from "./Content/Content";
import { Box, Stack } from "@mui/material";
import FooterLinks from "src/components/Footer/FooterLinks";
import RainbowFooter from "src/components/Footer/RainbowFooter";

export const MOBILE_NUMBER_PREFIX = "+49";

const IntroductionSMA = () => {
  return (
    <Stack
      sx={{
        minHeight: "100vh",
      }}
    >
      <Stack
        alignItems="center"
        sx={(theme) => ({
          width: "100%",
          minHeight: "100vh",
          backgroundColor: theme.palette.app.oppositePrimary,
          px: 4,
        })}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "fit-content",
            maxWidth: "1279px",
          }}
        >
          <Header />
          <Box
            sx={{
              height: "36px",
            }}
          />
          <Content />
        </Stack>
        <Box
          sx={{
            height: "36px",
          }}
        />
      </Stack>

      <FooterLinks isIntroductionPage={true} />
      <RainbowFooter />
    </Stack>
  );
};

export default IntroductionSMA;
